import {
  BooleanField,
  TextField,
  TimestampField,
  useStudioForm,
} from "~/components/Form";
import { FiltersSidebar, withoutBaseTableModel } from "~/components/Table";
import { CommonFilters } from "~/domain/common";
import { listDigestionTopicsSchema } from "../schemas";
import { useDigestionTopicSearchRequest } from "./DigestionTopicTable";

export function DigestionTopicFilters() {
  const [request, setRequest] = useDigestionTopicSearchRequest();

  const { control, handleSubmit } = useStudioForm({
    schema: listDigestionTopicsSchema,
    values: withoutBaseTableModel(request),
    onSubmit: setRequest,
  });

  return (
    <FiltersSidebar handleSubmit={handleSubmit}>
      <TextField control={control} name="id" />
      <TimestampField control={control} name="startTimeGte" />
      <TimestampField control={control} name="startTimeLte" />
      <BooleanField control={control} name="startTimeNull" />
      <TimestampField control={control} name="endTimeGte" />
      <TimestampField control={control} name="endTimeLte" />
      <BooleanField control={control} name="endTimeNull" />
      <CommonFilters control={control} />
    </FiltersSidebar>
  );
}
